<script setup lang="ts">
import { NavigationMenuRoot, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "reka-ui";

const { siteOptions } = useSiteOptions();
</script>

<template>
  <NavigationMenuRoot v-if="siteOptions" id="menu-top" class="links:link-primary text-black">
    <NavigationMenuList class="list-divided-x divide-x-2 divide-primary">
      <NavigationMenuItem v-for="item in siteOptions.top_menu_items" :key="item.id" :class="item.class">
        <NavigationMenuLink :href="item.url" :target="item.target">
          {{ item.title }}
        </NavigationMenuLink>
      </NavigationMenuItem>
      <UiSocialMedias :items="siteOptions.contact.social_medias" class="flex" />
    </NavigationMenuList>
  </NavigationMenuRoot>
</template>
